<template>
  <Dialog :visible="visible" modal :style="{ width: '30rem' }" :breakpoints="{ '640px': '95vw' }" header="إضافة قسم" @update:visible="$emit('update:visible', $event)">
    <ul class="hb-catalog">
      <li v-for="option in catalog" :key="option.key" class="hb-catalog__item" :class="{ 'hb-catalog__item--exists': exists(option) }">
        <button
          type="button"
          class="hb-catalog__btn"
          :disabled="exists(option) || adding"
          @click="add(option)"
        >
          <span class="hb-catalog__icon">{{ option.icon }}</span>
          <span class="hb-catalog__label">{{ option.label }}</span>
          <span v-if="exists(option)" class="hb-catalog__badge">مضاف بالفعل</span>
        </button>
      </li>
    </ul>

    <template #footer>
      <button class="ds-btn ds-btn--primary" @click="$emit('update:visible', false)">إغلاق</button>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import Swal from 'sweetalert2';
import { useHomepageSectionStore } from '@/stores/useHomepageSectionStore.js';

// Mirrors backend App\Support\HomepageDefaults — one catalog entry per
// unique `key` this table can ever hold. Once a section with a given key
// exists it can never be added again (each is disabled + shown as already
// added); this is not a generic "add unlimited sections" flow, matching the
// reference implementation exactly. `home_products` is the one type with
// two distinct catalog rows (academic_years_products / courses_products),
// disambiguated only by `key` — the backend `type` column is identical for
// both, distinguished at runtime by settings.kind.
const CATALOG = [
  { key: 'header', type: 'header', icon: '🖥️', label: 'الهيدر' },
  { key: 'hero', type: 'hero', icon: '🏠', label: 'الترحيب / Hero' },
  { key: 'banners', type: 'banners', icon: '📢', label: 'البانرات الإعلانية' },
  { key: 'quick_access', type: 'quick_access', icon: '⚡', label: 'الوصول السريع' },
  { key: 'academic_systems', type: 'academic_systems', icon: '🎓', label: 'الأنظمة الدراسية' },
  { key: 'academic_years_products', type: 'home_products', icon: '📅', label: 'السنوات الدراسية' },
  { key: 'courses_products', type: 'home_products', icon: '📚', label: 'الكورسات' },
  { key: 'statistics', type: 'statistics', icon: '📈', label: 'الإحصائيات' },
  { key: 'testimonials', type: 'testimonials', icon: '💬', label: 'آراء الطلاب' },
  { key: 'cta', type: 'cta', icon: '🚀', label: 'دعوة لإجراء (CTA)' },
  { key: 'footer', type: 'footer', icon: '🦶', label: 'الفوتر' },
];

export default {
  name: 'AddSectionDialog',
  components: { Dialog },
  props: {
    visible: { type: Boolean, default: false },
  },
  emits: ['update:visible'],
  data() {
    return { adding: false };
  },
  computed: {
    store() { return useHomepageSectionStore(); },
    catalog() { return CATALOG; },
  },
  methods: {
    exists(option) {
      return this.store.sections.some((s) => s.key === option.key);
    },
    async add(option) {
      if (this.exists(option) || this.adding) return;
      this.adding = true;
      try {
        await this.store.createSection({ key: option.key, type: option.type });
        Swal.fire({ icon: 'success', title: 'تمت الإضافة', timer: 1200, showConfirmButton: false });
      } catch (e) {
        Swal.fire({ icon: 'error', title: e?.response?.data?.message || 'تعذّرت الإضافة', timer: 2200, showConfirmButton: false });
      } finally {
        this.adding = false;
      }
    },
  },
};
</script>

<style scoped>
.hb-catalog {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.6rem;
}
.hb-catalog__btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 0.8rem;
  border: 1px solid var(--surface-border, #e5e7eb);
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  text-align: right;
  font-family: inherit;
}
.hb-catalog__btn:disabled {
  cursor: default;
  opacity: 0.55;
  background: var(--surface-100, #f1f5f9);
}
.hb-catalog__icon { font-size: 1.1rem; flex-shrink: 0; }
.hb-catalog__label { flex: 1; font-weight: 700; font-size: 0.85rem; min-width: 0; }
.hb-catalog__badge {
  font-size: 0.65rem;
  font-weight: 700;
  color: #64748b;
  background: rgba(148, 163, 184, 0.15);
  border-radius: 999px;
  padding: 0.15rem 0.5rem;
  white-space: nowrap;
}
</style>
